import api from "../../services/api"
export const FETCH_GETADDRESSES_FULFILLED = "FETCH_GETADDRESSES_FULFILLED";
export const FETCH_GETADDRESSES_REJECTED = "FETCH_GETADDRESSES_REJECTED";
export const FETCH_GETADDRESSES_PENDING = "FETCH_GETADDRESSES_PENDING";
export const RESET_GETADDRESSES = "RESET_GETADDRESSES";


export function getAddresses() {
  return (dispatch) => {
      dispatch({ type: FETCH_GETADDRESSES_PENDING });
      api.get("/gate/users/address/get-all")
          .then(response => {
              dispatch({
                  type: FETCH_GETADDRESSES_FULFILLED,
                  payload: response.data,
              });
          })
          .catch(error => {
              dispatch({
                  type: FETCH_GETADDRESSES_REJECTED,
                  payload: error,
              });
          });
  };
}

export function resetGetAddresses() {
  return (dispatch) => {
      dispatch({
          type: RESET_GETADDRESSES,
      });
  };
}